import { ActionIcon, Group, Modal } from "@mantine/core";
import { useAppTranslation } from "../hooks/useTranslation";

type YesNoDialogProps = {
  opened: boolean;
  title: string;
  question: string;
  onClose: () => void;
  onYes: () => void;
  onNo?: () => void;
};

export const YesNoDialog = (props: YesNoDialogProps) => {
  const { opened, title, question, onClose, onYes, onNo } = props;
  const { t } = useAppTranslation();

  return (
    <Modal opened={opened} onClose={onClose} title={title}>
      <p>{question}</p>
      <Group mt="md">
        <ActionIcon
          onClick={() => {
            onYes();
            onClose();
          }}
        >
          {t("common.yes")}
        </ActionIcon>
        <ActionIcon
          onClick={() => {
            onNo && onNo();
            onClose();
          }}
        >
          {t("common.no")}
        </ActionIcon>
      </Group>
    </Modal>
  );
};
